import { line } from 'd3-shape';
import React from 'react';
import { useStrip } from '../hooks/useStrip';
import { GRID_UNIT_SIZE, squareToPixel } from '../utils/graph.utils';

interface Props {
  start: number;
  end: number;
}
const ITEM_SIZE = squareToPixel(3 / 8);

export const LaddergramLink: React.FC<Props> = ({ start, end }) => {
  const { xScale } = useStrip();
  const innerSize = xScale(end - start);

  const points: [number, number][] = [
    [0, 0],
    [innerSize, squareToPixel(1 / 2)],
  ];
  const pathD = line()(points) || undefined;

  return (
    <g transform={`translate(${xScale(start)}, ${ITEM_SIZE / 2})`}>
      <path stroke='black' strokeWidth={GRID_UNIT_SIZE} d={pathD} />
    </g>
  );
};
